import http from "@/utils/http.js";

/**
 * 管理员登录系统
 * @param {*} params 登录参数
 */
export const appVersion = () => {
  return http.get("appVersion/checkNoAuth");
};
